
import { Component, Vue } from "vue-property-decorator";
import YesIcon from "@/components/Icons/YesIcon.vue";
import YesIconGrey from "@/components/Icons/YesIconGrey.vue";
import NoIcon from "@/components/Icons/NoIcon.vue";

@Component({
    components:{
        YesIcon,
        YesIconGrey,
        NoIcon
    }
})
export default class AdvantagesTable extends Vue {

};
